/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { lodash, classnames as cx, propsUtils } from '@ba-ui-toolkit/utils';
import TextArea from '@ba-ui-toolkit/textarea';
import PropertiesPane from '../PropertiesPane';
import styles from './SectionStyles.scss';

const { uniqueId } = lodash;
const { sanitize, getInheritedProps } = propsUtils;

const textAreaSectionClassName = styles.textAreaSectionClassName.replace(/"/g, ''); // eslint-disable-line no-unused-vars

export default class TextAreaSection extends Component {
	static propTypes = {
		label: PropTypes.string.isRequired,
		title: PropTypes.string,
		placeholder: PropTypes.string,
		value: PropTypes.string,
		className: PropTypes.string,
		labelSize: PropTypes.oneOf(['small', 'medium', 'large', 'full']),

		rows: PropTypes.number,

		fireOnBlur: PropTypes.bool,
		disabled: PropTypes.bool,
		readOnly: PropTypes.bool,
		rtl: PropTypes.bool,

		onChange: PropTypes.func,
		style: PropTypes.object,
		...TextArea.propTypes,
		...PropertiesPane.propTypes,
	};

	static defaultProps = {
		labelSize: 'full',
		className: '',
		style: {},
	};

	constructor(props) {
		super(props);
		this._id = uniqueId('__textAreaSection_');
		this._propLabelId = `${this._id}_propLabel_`;
	}

	render() {
		const {
			label,
			title,
			placeholder,
			rows,
			value,
			disabled,
			rtl,
			fireOnBlur,
			onChange,
			readOnly,
			className,
			labelSize,
			style,
			...others
		} = this.props;
		const classNames = cx(textAreaSectionClassName);
		const textAreaPassthroughProps = getInheritedProps(others, TextArea);
		const propertiesPanePassthroughProps = getInheritedProps(others, PropertiesPane);

		return (
			<PropertiesPane
				{...sanitize(others, TextAreaSection)}
				{...propertiesPanePassthroughProps}
				className={`${classNames} ${className}`}
				label={label}
				title={title}
				disabled={disabled}
				labelSize={labelSize}
				htmlFor={this._id}
				labelId={this._propLabelId}
				rtl={rtl}
				style={style}
			>
				<TextArea
					aria-labelledby={this._propLabelId}
					data-tid="ba-common-textarea-section__textarea"
					{...textAreaPassthroughProps}
					id={this._id}
					value={value}
					rows={rows}
					onChange={onChange}
					disabled={disabled}
					readOnly={readOnly}
					placeholder={placeholder}
					fireOnBlur={fireOnBlur}
				/>
			</PropertiesPane>
		);
	}
}
